import type { JSX } from 'react';
import type { BariPostCaroWeightMeasurementsReadData } from '@common/validation/customControls/bariPost/bariPostCaroBodyWeightMeasurements/v1/bariPostCaroBodyWeightMeasurementsSchemaV1';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { BariPostTotalWeightLossFormGroup } from './BariPostTotalWeightLossFormGroup';

export function BariPostCaroWeightMeasurementsRead(): JSX.Element {
    const { readSections } = useDefinedContext(ProcessActivityReadContext);

    return <ReadForm components={getComponents()} />;

    function getComponents(): ComponentsMap {
        const map: ComponentsMap = new Map();
        addTotalWeightLossComponent(map);

        return map;
    }

    function addTotalWeightLossComponent(map: ComponentsMap): void {
        const totalWeightLossItem = getProcessActivityReadSectionItem<BariPostCaroWeightMeasurementsReadData>()(
            readSections,
            'totalWeightLossData'
        );
        if (totalWeightLossItem) {
            map.set(totalWeightLossItem.key, <BariPostTotalWeightLossFormGroup {...totalWeightLossItem.value} />);
        }
    }
}
